import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses';
import { transformWarehousesForForm } from 'shared/utils/warehouses/transform-warehouses-for-form';
import type { IWarehouseSelectorProps } from './types';

export const WarehouseSelector = (props: IWarehouseSelectorProps) => {
  const { value, onChange } = props;
  const { t } = useTranslation('trip');
  const { data: warehouses } = useGetManyWarehouses({ withDeprecated: true });

  const transformedWarehouses = useMemo(() => transformWarehousesForForm(warehouses, value), [warehouses, value]);

  return (
    <Select
      optionFilterProp='label'
      placeholder={t('warehouse_placeholder')}
      value={value}
      options={transformedWarehouses}
      allowClear
      showSearch
      onChange={onChange}
    />
  );
};
